import { AxiosResponse } from "axios";
import { axiosInstance } from "src/services/axiosSetup";
import * as API from "src/services/consts/UploadBills";

export function uploadBillsApiRequest(data: any): Promise<AxiosResponse<any>> {
    return axiosInstance.post(`${API.UPLOAD_BILL_URL}`, data).then((d: AxiosResponse) => d.data)
}

